// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as CrisisRouteImport } from './routes/crisis'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as AuthenticatedTherapistsRouteImport } from './routes/_authenticated/therapists'
import { Route as AuthenticatedPricingRouteImport } from './routes/_authenticated/pricing'
import { Route as AuthenticatedMoodRouteImport } from './routes/_authenticated/mood'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCounselingRouteImport } from './routes/_authenticated/counseling'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/chat'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedAdminResendAttemptsRouteImport } from './routes/_authenticated/admin.resend-attempts'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const CrisisRoute = CrisisRouteImport.update({
            id: '/crisis',path: '/crisis',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const AuthenticatedTherapistsRoute = AuthenticatedTherapistsRouteImport.update({
            id: '/therapists',path: '/therapists',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPricingRoute = AuthenticatedPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMoodRoute = AuthenticatedMoodRouteImport.update({
            id: '/mood',path: '/mood',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCounselingRoute = AuthenticatedCounselingRouteImport.update({
            id: '/counseling',path: '/counseling',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminResendAttemptsRoute = AuthenticatedAdminResendAttemptsRouteImport.update({
            id: '/admin/resend-attempts',path: '/admin/resend-attempts',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedChatRoute: AuthenticatedChatRoute,AuthenticatedCounselingRoute: AuthenticatedCounselingRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedMoodRoute: AuthenticatedMoodRoute,AuthenticatedPricingRoute: AuthenticatedPricingRoute,AuthenticatedTherapistsRoute: AuthenticatedTherapistsRoute,AuthenticatedAdminResendAttemptsRoute: AuthenticatedAdminResendAttemptsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,CrisisRoute: CrisisRoute,UnsubscribeRoute: UnsubscribeRoute,CheckoutReturnRoute: CheckoutReturnRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)